import { RouteObject } from "react-router-dom";
import {
  PROJECT_CREATE,
  PROJECT_DETAIL,
  PROJECT_DETAIL_REQUIREMENT,
  PROJECT_SEARCH
} from "constants/urls";


export default [
  {
    index: true,
    lazy: () => import("modules/project/pages/Project"),
  },
  {
    path: PROJECT_CREATE,
    lazy: () => import("modules/project/pages/ProjectCreateEdit"),
  },
  {
    path: PROJECT_DETAIL,
    lazy: () => import("modules/project/pages/ProjectDetail"),
  },
  {
    path: PROJECT_DETAIL_REQUIREMENT,
    lazy: () => import("modules/project/pages/ProjectDetailRequirement"),
  },
  { path: PROJECT_SEARCH,
    lazy: () => import("modules/project/pages/ProjectSearch"),
  },
] as RouteObject[];
